import request from '@/utils/request';
import { endpoints, catalogueTemplateEndpoint } from '@/constants/urls';

const catalogueTemplates = (
  filter,
  includeEnabled,
  includeDisabled,
  page,
  pageSize,
) => {
  const params = { filter, page, pageSize };
  const enabledFlags = [includeEnabled, includeDisabled];
  const allSet = enabledFlags.every((v) => v === enabledFlags[0]);

  if (!allSet) {
    if (includeEnabled) {
      params.enabled = true;
    }
    if (includeDisabled) {
      params.disabled = true;
    }
  }

  return (request({
    url: endpoints.CATALOGUE_TEMPLATES,
    params,
    method: 'GET',
  }));
};

const catalogueTemplate = (code) => request({
  url: catalogueTemplateEndpoint(code),
  method: 'GET',
});

export default {
  catalogueTemplates,
  catalogueTemplate,
};
